export enum ColorEnum {
  RED_14 = "#d50000",
  RED_1 = "#f48fb1",
  PINK_14 = "#c51162",
  PINK_6 = "#e91e63",
  PURPLE_14 = "#aa00ff",
  PURPLE_6 = "#9c27b0",
  DEEP_PURPLE_14 = "#6200ea",
  DEEP_PURPLE_6 = "#673ab7",
  INDIGO_14 = "#304ffe",
  INDIGO_6 = "#3f51b5",
  BLUE_14 = "#2962ff",
  BLUE_6 = "#2196f3",
  LIGHT_BLUE_14 = "#0091ea",
  LIGHT_BLUE_6 = "#03a9f4",
  CYAN_14 = "#00b8d4",
  CYAN_5 = "#26c6da",
  CYAN_6 = "#00bcd4",
  TEAL_14 = "#00bfa5",
  TEAL_6 = "#009688",
  GREEN_14 = "#00c853",
  GREEN_6 = "#4caf50",
  LIGHT_GREEN_14 = "#64dd17",
  LIGHT_GREEN_6 = "#8bc34a",
  LIME_6 = "#cddc39",
  YELLOW_6 = "#ffeb3b",
  AMBER_14 = "#ffab00",
  AMBER_7 = "#ffb300",
  AMBER_6 = "#ffc107",
  ORANGE_14 = "#ff6d00",
  ORANGE_6 = "#ff9800",
  DEEP_ORANGE_14 = "#dd2c00",
  DEEP_ORANGE_6 = "#ff5722",
  BROWN_14 = "#5d4037",
  BROWN_6 = "#795548",
  GREY_14 = "#616161",
  GREY_6 = "#9e9e9e",
  BLUE_GREY_14 = "#455a64",
  BLUE_GREY_6 = "#607d8b",
}

export function randomColor() {
  const colors = Object.values(ColorEnum);
  return colors[Math.floor(Math.random() * colors.length)];
}
